/*
 * (C) Behaviour Interactive Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * This file is proprietary and confidential
 */

import { AnimatePresence, motion } from 'framer-motion';
import { ReactNode } from 'react';

const transitions = ['fadeIn', 'none'] as const;
type TransitionType = (typeof transitions)[number];

const variants = {
  visible: {
    opacity: 1,
    transition: {
      delay: 0.5,
      duration: 0.3,
    },
  },
  hidden: {
    opacity: 0,
    transition: {
      duration: 0.2,
    },
  },
};

interface Props {
  /**
   * Id of the transition.
   */
  id: string;
  /**
   * Children the transition wraps
   */
  children: ReactNode;
  /**
   * Transition type to apply
   */
  type?: TransitionType;
}

const PageTransition = ({ id, children, type }: Props) => {
  return type === 'none' ? (
    children
  ) : (
    <AnimatePresence mode='sync'>
      <motion.div className='grow' key={id} initial={'hidden'} animate={'visible'} exit={'hidden'} variants={variants}>
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default PageTransition;

export const isValidTransition = (x: unknown): x is TransitionType => {
  return typeof x === 'string' && transitions.includes(x as TransitionType);
};
